import { endOfDay, isAfter, isBefore, isValid } from "date-fns";
import { isEqual, isNil, isString } from "lodash";
import { valueFormatterDate } from "../../../../utils/agGrid/valueFormatter/valueFormatterDate";
import { isoToDate } from "../../../../utils/dates/isoToDate";
import { formatDateTime } from "../../functions/formatDateTime";
//2025-06-05T17:02:08.420000
export const columnTypesDate = () => {
  return {
    date: {
      // display formatter stays the same
      valueFormatter: (p) => valueFormatterDate(p),

      // Convert any input to ISO string format when value changes
      valueParser: (params) => {
        const v = params.newValue;
        let d;

        if (v instanceof Date) {
          d = v;
        } else if (isString(v)) {
          d = isoToDate(v);
        } else {
          return v;
        }

        // If we have a valid date, return it as an ISO string
        if (isValid(d)) {
          return d.toISOString();
        }

        return v;
      },

      numAlwaysVisibleConditions: 1,
      filter: "agDateColumnFilter",
      cellEditor: "agDateCellEditor",
      filterParams: filterParamsDate,
    },

    dateTime: {
      numAlwaysVisibleConditions: 1,
      valueFormatter: valueFormatterDateTime,
      filter: "agDateColumnFilter",
      filterParams: filterParamsDate,
    },
  };
};

const valueFormatterDateTime = (params, format) => {
  const d = params?.value;
  if (isNil(d) || !isString(d)) {
    return;
  }
  return formatDateTime(d);
};

const filterParamsDate = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    if (cellValue == null) {
      return 0;
    }
    const sel = endOfDay(filterLocalDateAtMidnight);
    const cellDate = endOfDay(new Date(cellValue));
    if (isBefore(cellDate, sel)) return -1;
    if (isEqual(cellDate, sel)) return 0;
    if (isAfter(cellDate, sel)) return 1;
    return 0;
  },
};
